<template>
  <div class="component-container card-overflow">
    <v-card class="component-container component-overflow card-login">
      <v-form
        ref="formConfirmAccount"
        v-model="formValid"
        @submit.prevent="sendRequest"
        class="h-100 d-flex flex-column"
      >
        <v-container class="logo-container">
          <img alt="logo Boomerang" class="logo" src="@/assets/images/boomerang_black_logo.png" />
        </v-container>
        <v-spacer />
        <v-container>
          <h1 class="title">{{ $t('INIT_PASSWORD.TITLE') }}</h1>
          <div class="subtitle">{{ $t('INIT_PASSWORD.PASSWORD') }}</div>
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            required
            v-model="password"
            :rules="[...requiredRules, ...passwordRules]"
            @click:append-inner="togglePasswordVisibility"
            :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          >
          </v-text-field>
          <div class="subtitle">{{ $t('INIT_PASSWORD.CONFIRM_PASSWORD') }}</div>
          <v-text-field
            :type="showConfirmPassword ? 'text' : 'password'"
            required
            v-model="confirmPassword"
            :rules="[...requiredRules, ...passwordRules, ...confirmPasswordRules]"
            @click:append-inner="toggleConfirmPasswordVisibility"
            :append-inner-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          >
          </v-text-field>
        </v-container>
        <v-spacer />
        <v-container class="bottom-container">
          <v-btn
            class="boom-button"
            variant="outlined"
            @click="sendRequest"
            :disabled="loading || !formValid"
            :loading="loading"
          >
            {{ $t('INIT_PASSWORD.BUTTON.SUBMIT') }}
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import Validator from '/src/components/utils/validator'
import { displayToast } from '@/components/utils/globalFunction'
import router from '@/router'
import AuthService from '@/services/AuthService'

export default {
  name: 'ConfirmationAccountPage',
  data() {
    return {
      loading: false,
      token: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      formValid: false,
      requiredRules: Validator.requiredRules,
      passwordRules: Validator.passwordRules
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    this.token = urlParams.get('token')
  },
  computed: {
    confirmPasswordRules() {
      return Validator.confirmPasswordRule(this.password)
    }
  },
  methods: {
    async sendRequest() {
      try {
        await AuthService.InitializePassword({
          password: this.password,
          confirm_password: this.confirmPassword,
          token: this.token
        })
        displayToast(this.$t('INIT_PASSWORD.SUCCESS'), 'success')
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.key === 'invalid_captcha_token'
        ) {
          displayToast(this.$t('INIT_PASSWORD.ERROR'), 'error')
        } else {
          displayToast(
            this.$t(
              'ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')
            ),
            'error'
          )
        }
      }
      await router.push({ path: '/login' })
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword
    }
  }
}
</script>

<style scoped>
.card-overflow {
  overflow: hidden;
  position: relative;
  background-color: transparent !important;
}

.card-login {
  z-index: 2;
  position: absolute;
}

:deep(.v-field) {
  overflow: hidden;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subtitle {
  line-height: 20px;
  text-align: left;
  margin-bottom: 2%;
}

.title {
  text-align: center;
  font-size: 150%;
  font-style: normal;
  padding-bottom: 10%;
}

.link:hover {
  color: #559a1b;
}

.boom-button {
  width: 100%;
}

.component-container {
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 5%;
  padding: 0 7%;
  transition: transform 0.3s;
}

.component-overflow {
  overflow-y: auto;
}

.bottom-container {
  padding-bottom: 36px;
}

@media (max-width: 499px) {
  .component-container {
    width: 90vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 500px) and (max-width: 767px) {
  .component-container {
    width: 70vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 768px) and (max-width: 1099px) {
  .component-container {
    width: 40vw;
    height: 80vh;
  }
}

@media (min-width: 1100px) and (max-width: 1599px) {
  .component-container {
    width: 30vw;
    height: 80vh;
  }
}

@media (min-width: 1600px) {
  .component-container {
    width: 20vw;
    height: 80vh;
  }
}

:deep(i.v-icon.v-icon) {
  color: lightgrey !important;
}

:deep(.v-text-field .v-input__details) {
  padding-inline-start: unset;
  padding-inline-end: unset;
}

.logo-container {
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;
  padding: unset;
}

.logo {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  justify-content: center;
  width: 90%;
}
</style>
